module.exports = __webpack_public_path__ + "static/media/user-contact-icon.da8cc5f4.svg";